import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=98ec5df4&"
import script from "./PieChart.vue?vue&type=script&lang=js&"
export * from "./PieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98ec5df4')) {
      api.createRecord('98ec5df4', component.options)
    } else {
      api.reload('98ec5df4', component.options)
    }
    module.hot.accept("./PieChart.vue?vue&type=template&id=98ec5df4&", function () {
      api.rerender('98ec5df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/PieChart.vue"
export default component.exports